import React, {useEffect, useState} from 'react';
import {GetCookieInfo} from "../../../logic/CookieManager";
import {Paper, Snackbar, TableBody, TableHead, Typography} from "@mui/material";
import {
    StyledAlert,
    StyledTable, StyledTableBodyRow, StyledTableCell,
    StyledTableCellHeader, StyledTableContainer,
    StyledTableHeadRow
} from "../../../styles/MyStyles";
import {GetClient} from "../../../logic/DataProvider";
import {GetLookupValueName} from "../../../logic/LookupHelper";
import dayjs from "dayjs";
import * as MyStyles from "../../../styles/MyStyles";

const AmlPage = React.forwardRef((props, ref) => {
    const clientId = props.clientId;
    const [client, setClient] = useState();
    const [snackbar, setSnackbar] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
        message: ''
    });
    const [checks, setChecks] = useState();

    React.useImperativeHandle(ref, () => ({
        handleNewCheck,
        handleRefreshChecksClick
    }));
    const fetchChecks = async (client) => {
        try {
            const tokenCookie = GetCookieInfo('nplt');

            let endpoint, body;
            if (client.type === 0) {
                endpoint = "onfido-checks";
                body = {
                    'firstName': client.privateMetadata.firstName,
                    'lastName': client.privateMetadata.lastName,
                    'dateOfBirth': client.privateMetadata.dateOfBirth,
                    'nationality': GetLookupValueName('nationality', client.privateMetadata.nationalityId)
                };
            } else {
                endpoint = "namescan-checks";
                body = {
                    'name': client.legalMetadata.name,
                    'country': GetLookupValueName('country', client.legalMetadata.registrationCountryId),
                };
            }

            const response = await fetch(
                `${process.env.REACT_APP_AML_URL}/${endpoint}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(body),
                }
            );
            if (response.ok) {
                const data = await response.json();
                if (data.data) {
                    data.data.sort((a, b) => {
                        const dateA = new Date(a.createdAtIso);
                        const dateB = new Date(b.createdAtIso);
                        return dateB - dateA;
                    });
                }
                setChecks(data.data ?? []);
                console.log(data.data);

            } else {
                console.log('Fetch checks failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };
    useEffect(() => {
        GetClient(clientId).then((value) => {
            setClient(value);
            fetchChecks(value);
        });
    }, [clientId]);

    const handleNewCheck = () => {
        fetchNewCheck();
    };
    const handleRefreshChecksClick = () => {
        fetchChecks(client);
    };

    const fetchNewCheck = async () => {
        try {
            const tokenCookie = GetCookieInfo('nplt');

            let endpoint, body;
            if (client.type === 0) {
                endpoint = "onfido-check";
                body = {
                    'firstName': client.privateMetadata.firstName,
                    'lastName': client.privateMetadata.lastName,
                    'dateOfBirth': client.privateMetadata.dateOfBirth,
                    'nationality': GetLookupValueName('nationality', client.privateMetadata.nationalityId)
                };
            } else {
                endpoint = "namescan-check";
                body = {
                    'name': client.legalMetadata.name,
                    'country': GetLookupValueName('country', client.legalMetadata.registrationCountryId),
                };
            }

            const response = await fetch(
                `${process.env.REACT_APP_AML_URL}/${endpoint}`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                        Authorization: 'Bearer ' + tokenCookie.value,
                    },
                    body: JSON.stringify(body),
                }
            );
            if (response.ok) {
                const data = await response.json();
                console.log(data.data);
                if (data.data) {
                    setChecks((prevState) => [...prevState, data.data]);
                }
            } else {
                console.log('Fetch new check failed.');
            }
        } catch (error) {
            console.log('An error occurred:', error);
        }
    };
    const handleCloseSnackbar = () => {
        setSnackbar({ ...snackbar, open: false });
    };
    return (
        <>
            <Snackbar
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}>
                <StyledAlert onClose={handleCloseSnackbar} severity="error" sx={{ width: '100%' }}>
                    {snackbar.message}
                </StyledAlert>
            </Snackbar>
            {checks && checks.length === 0 && (<Typography variant="h6" component="h2">
                There are no checks yet.
            </Typography>)}
            {checks && checks.length !== 0 && client.type === 0 && (<StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={4}>Date</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={4}>Result</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={4}>Status</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={4}>ReportTypes</StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {checks.map((entity) => (
                            <StyledTableBodyRow key={entity.id}>
                                <StyledTableCell>{entity.createdAtIso ? dayjs(new Date(entity.createdAtIso)).format(MyStyles.DateFormat) : '-'}</StyledTableCell>
                                <StyledTableCell>{entity.result ?? '-'}</StyledTableCell>
                                <StyledTableCell>{entity.status}</StyledTableCell>
                                <StyledTableCell>{entity.reportTypes}</StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>)}
            {checks && checks.length !== 0 && client.type === 1 && (<StyledTableContainer component={Paper}>
                <StyledTable>
                    <TableHead>
                        <StyledTableHeadRow>
                            <StyledTableCellHeader columncount={2}>Date</StyledTableCellHeader>
                            <StyledTableCellHeader columncount={2}>Number Of Matches</StyledTableCellHeader>
                        </StyledTableHeadRow>
                    </TableHead>
                    <TableBody>
                        {checks.map((entity) => (
                            <StyledTableBodyRow key={entity.scanId}>
                                <StyledTableCell>{entity.createdAtIso ? dayjs(new Date(entity.createdAtIso)).format(MyStyles.DateFormat) : '-'}</StyledTableCell>
                                <StyledTableCell>{entity.numberOfMatches ?? '-'}</StyledTableCell>
                            </StyledTableBodyRow>
                        ))}
                    </TableBody>
                </StyledTable>
            </StyledTableContainer>)}
        </>
    );
});

export default AmlPage;
